import { call, put, takeEvery } from 'redux-saga/effects';

import { TRANSLATION_RULES_REQUEST } from './actionTypes';
import { translationRulesSuccess, translationRulesFailure } from './actions';
import TranslationRulesService from '../../services/TranslationRulesService';

function* fetchTranslation(action) {
  try {
    const translationRules = yield call(
      TranslationRulesService.getAll,
      action.payload.client,
    );
    yield put(translationRulesSuccess(translationRules));
  } catch (error) {
    yield put(translationRulesFailure(error));
  }
}

export function* translationRulesSaga() {
  yield takeEvery(TRANSLATION_RULES_REQUEST, fetchTranslation);
}
